import Axios from '../axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { deserialize, serialize } from '../utility/serialization'
import { handleAPIError } from '../utility/actionHelper'

// THUNKS

export const updateEnrollment = createAsyncThunk(
  'enrollment/updateEnrollment',
  async ({ enrollmentData, coachMessage, notifyViaEmail }, { rejectWithValue }) => {
    try {
      const { data } = await requestUpdateEnrollment(enrollmentData, coachMessage, notifyViaEmail)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const deleteEnrollment = createAsyncThunk(
  'enrollment/deleteEnrollment',
  async ({ enrollmentId, refund, coachMessage, notifyViaEmail }, { rejectWithValue }) => {
    try {
      const { data } = await requestDeleteEnrollment(enrollmentId, refund, coachMessage, notifyViaEmail)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const transferEnrollment = createAsyncThunk(
  'enrollment/transferEnrollment',
  async ({ enrollmentId, courseId, coachMessage, sendEmail }, { rejectWithValue }) => {
    try {
      const { data } = await requestTransferEnrollment(enrollmentId, courseId, coachMessage, sendEmail)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const addProgramEnrollmentsManually = createAsyncThunk(
  'enrollment/addEnrollmentsManually',
  async ({ programId, userIds, message }, { rejectWithValue }) => {
    try {
      const { data } = await requestPostProgramEnrollments(userIds, programId, message)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

// API CALLS

const requestPostProgramEnrollments = (userIds, programId, message) => {
  const requestUrl = `/api/v1/courses/${programId}/enrollments`

  return Axios.post(requestUrl, serialize({ userIds, coachMessage: message }))
}

function requestUpdateEnrollment(enrollment, coachMessage = '', notifyViaEmail) {
  const requestUrl = `/api/v1/enrollments/${enrollment.id}`
  const body = { ...serialize(enrollment), coach_message: coachMessage }
  if (notifyViaEmail !== undefined) { body.send_email = notifyViaEmail }

  return Axios.patch(requestUrl, body)
}

function requestDeleteEnrollment(enrollmentId, refund, coachMessage = '', notifyViaEmail = false) {
  const requestUrl = `/api/v1/enrollments/${enrollmentId}`

  return Axios.delete(requestUrl, { params: { refund, coach_message: coachMessage, send_email: notifyViaEmail } })
}

function requestTransferEnrollment(enrollmentId, courseId, coachMessage = '', sendEmail = true) {
  const requestUrl = `/api/v1/enrollments/${enrollmentId}/transfer`

  return Axios.patch(requestUrl, serialize({ courseId, coachMessage, sendEmail }))
}

export const requestGetEnrollmentsExist = (communityId) => {
  const requestUrl = `/api/v1/communities/${communityId}/enrollments/exist`

  return Axios.get(requestUrl)
}
